import React from 'react'
import CompanyProfile from './CompanyProfile'
import CompanyBillingInformation from './CompanyBillingInformation'
import CompanyPaymentOptions, {
  CompanyPaymentMethod,
  hasSubscriptionBankDetails,
} from './CompanyPaymentOptions'
import { PaymentMethodType } from '../../../interfaces/subscription'
import { useReportsContext } from '../../../context/reports/reports'

/** This screen offers two options, so every method that is not the manual bank
 *  transfer - card, SEPA direct debit, and the catch-all `other` the Stripe
 *  webhook assigns - collapses onto the card option. */
const toCompanyPaymentMethod = (
  type?: PaymentMethodType | null,
): CompanyPaymentMethod | undefined => {
  if (!type) return undefined
  return type === 'bank_transfer' ? 'bank_transfer' : 'card'
}

const CompanySettings = () => {
  const { selectedOrg } = useReportsContext()

  return (
    <>
      <CompanyProfile />
      <hr className='m-auto w-full border-[#E2E2E2]' />
      {/* Hidden until REACT_APP_SUBSCRIPTION_BANK_DETAILS is set: with no
          details to reveal the section only restates the method shown on Plan
          & Billing, as tiles that look editable but are not. The separator
          travels with it so the screen does not keep a stray rule. */}
      {hasSubscriptionBankDetails && (
        <>
          <CompanyPaymentOptions
            value={toCompanyPaymentMethod(selectedOrg?.payment_method?.type)}
          />
          <hr className='m-auto w-full border-[#E2E2E2]' />
        </>
      )}
      <CompanyBillingInformation />
    </>
  )
}

export default CompanySettings
